var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.407 2.43579H2.229C1.83674 2.43579 1.46056 2.59161 1.18319 2.86898C0.905823 3.14635 0.75 3.52254 0.75 3.91479V14.2708C0.75 14.663 0.905823 15.0392 1.18319 15.3166C1.46056 15.594 1.83674 15.7498 2.229 15.7498H12.585C12.9773 15.7498 13.3534 15.594 13.6308 15.3166C13.9082 15.0392 14.064 14.663 14.064 14.2708V9.09279",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8713 1.24389C13.0281 1.08735 13.2142 0.963235 13.419 0.878619C13.6237 0.794003 13.8432 0.750547 14.0647 0.750733C14.2863 0.750919 14.5056 0.794742 14.7103 0.879701C14.9149 0.964661 15.1008 1.08909 15.2573 1.24589C15.4138 1.40269 15.538 1.58878 15.6226 1.79355C15.7072 1.99832 15.7506 2.21774 15.7505 2.4393C15.7503 2.66086 15.7064 2.88022 15.6215 3.08484C15.5365 3.28947 15.4121 3.47535 15.2553 3.63189L7.7073 11.1799L4.5293 11.9699L5.3243 8.79189L12.8713 1.24389Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.dec97c5f6147f23bda7543b0edc90260.svg";
export { ForwardRef as ReactComponent };